import dagre from 'dagre';
const findChildrenNode = (nodes, edges, parentId) => {
    let workingNodes = [...nodes];
    let workingEdges = [...edges];

    const dagreGraph = new dagre.graphlib.Graph()
        .setDefaultEdgeLabel(() => ({}))
        .setGraph({});

    workingNodes.forEach((node) => {
        dagreGraph.setNode(node.id, {
            data: node.data,
        });
    });

    workingEdges.forEach((edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
    });

    const children = dagreGraph.successors(parentId); // true = [...] || false = []
    return children;
};

export default findChildrenNode;